

(function ($, console) {
  //Attach this new method to jQuery
  $(document).ready(function () {
      
    $.extend($.ajaxActionHandlers, {
        cancelAttachmentUpload: function (actionData) {
            //console.log("cancel", actionData);
        for (var key in actionData.Data.FieldNames) {
          $("tr#" + actionData.Data.FieldNames[key]).find('td:nth-child(2)').text(actionData.Data.Message);
          $("tr#" + actionData.Data.FieldNames[key]).addClass("error");
          $("tr#" + actionData.Data.FieldNames[key]).find('td').addClass('strikethru');
          $("tr#" + actionData.Data.FieldNames[key]).find('td').find('a').each(function () {
            $(this).parent().text($(this).text());
          });
          if (window.progressTimer)
            window.clearTimeout(window.progressTimer);

        }
      },
      reuploadAttachment: function (data, originalEventData) {
       
        var el = $('input[type="file"]').filter('[name="' + data.Data + '"]');
        el.removeAttr('uploaded');
        el.attr('reupload', 'true');
        var td = $('tr#' + data.Data).find('td:nth(1)');
        
        td.html("<div id='uploadProgress_grid" + td.parents('table').attr('id') + "_" + data.Data + "'>u</div>");
        $.ajaxUpload(el.data('uploadUrl'), el.data('uploadKey'), el, data.Data, el.data('callback'), el.data('asSingleRequest'));
      }
			,
      warnAttachmentUpload: function (actionData) {

        $.confirmDialog(actionData.Data.Message, function () { }, function () { });
      }

    });

  });
  $.fn.extend({

    //This is where you write your plugin's name
      uploadHelper: function (uploadKey) {
          if (new XMLHttpRequest().upload == undefined) {
              $(this).removeAttr('multiple');
          }
          if (console.isInfoEnabled)
        console.group("Creating uploadHelper");
      if (uploadKey == undefined)
        uploadKey = $(this).data('uploadKey');
      if (console.isDebugEnabled) {
        console.log("Upload key: %s", uploadKey);
        console.log("Element length: %i", $(this).length);
      }

        
      // Calls ajaxUpload function for the selected element
      this.upload = function (url, data, callback) {
          $(this).data('uploadUrl', url);
         
        $(this).data('callback', callback);
        $(this).data('fileData', data);
        $(this).data('uploadKey', uploadKey);
        console.log('uploadHelper.upload', url, false, data, callback);
        return $.ajaxUpload(url, uploadKey, $(this), data, callback, false);
      };

      // Clones an uploadElement. Appends _1,_2,_3,_n to the existing element's name and 
      // uses the original name for the new element
      this.cloneUpload = function () {
        if (console.isDebugEnabled)
          console.group("function cloneUpload");

        var element = $(this).clone(true).uploadHelper(uploadKey);
        
        var index = $(this).data('uploadElementIndex');

        if (index == null) {
          index = 1;
          $(this).data('uploadElementIndex', index)
        }
        $(this).attr('name', $(this).attr('name') + "_" + index);
        $(this).attr('id', $(this).attr('id') + "_" + index);
        $(this).removeAttr('uploaded');
        element.data('uploadElementIndex', index + 1);
        if (console.isDebugEnabled) {
          console.group("Element cloned");
          console.log("Name: " + $(this).attr('name'));
          console.log("ID: " + $(this).attr('id'));
          console.log("UploadElementIndex: " + $(this).data('uploadElementIndex'));
          console.groupEnd();
        }
        console.groupEnd();
        return element;

      };
      // Clones an uploadElement using the cloneUpload function, and then unbinds the fileSelected/change events
      // on the original element and hides it.
      this.cloneAndReplaceUpload = function (data) {
          
        if (console.isDebugEnabled)
          console.group("function cloneAndReplaceUpload", arguments.callee);
        var newEl = this.cloneUpload();
        newEl.insertAfter($(this)).val('');
        if (console.isDebugEnabled)
          console.debug("Unbinding fileSelected for element", this);
        $(this).unbind('fileSelected');
        if (console.isDebugEnabled)
          console.debug("Unbinding change  for element", this);
        $(this).unbind('change');
        if (console.isDebugEnabled)
          console.debug("Hiding element ", this);
        $(this).hide();
        if (console.isDebugEnabled)
          console.groupEnd();
        return newEl;
      };
      //Iterate over the current set of matched elements
      if (console.isInfoEnabled) {
        if (console.isDebugEnabled)
          console.groupCollapsed("Matched elements");
        this.each(function () { console.log(this); });
        if (console.isDebugEnabled)
          console.groupEnd();
        console.groupEnd();
      }
      return this.each(function () {

        // If fileUpload is undefined, set it to true then bind change event.
        // This fileUpload check prevents binding to the change event twice.
        if ($(this).data('fileUpload') == undefined || !$(this).data('fileUpload')) {
          $(this).data('fileUpload', true);
            $(this).data('uploadKey', uploadKey);

          $(this).change(function () {
            console.debug("Change event has fired for ", this);
            var fileName = $(this).val();
            console.debug("New file name", fileName);
            if (fileName.indexOf('\\') >= 0) {

              fileName = fileName.substr(fileName.lastIndexOf('\\') + 1);

            }
              
            if ($.usingHtml5FileUpload || this.files != undefined && this.files.length > 1) {
                
                for (var f = 0; f < this.files.length; f++)
                {
                    var fileName = this.files[f].name;
                    if (fileName.indexOf('\\') >= 0) {

                        fileName = fileName.substr(fileName.lastIndexOf('\\') + 1);

                    }
                    console.log("Triggering fileselected event");
                    $(this).trigger('fileselected', this.files[f]);
                }
                  
              } else {
                  console.log("Triggering fileselected event");
                  $(this).trigger('fileselected', { name: fileName });
              }
          });
        }
      });

    }
  });
  $.extend({
      ajaxPerformUpload: function (url, uploadKey, el, fileData, callback) {
          if (fileData.name == undefined && (typeof fileData == "string" || fileData instanceof String))
              fileData = { name: fileData };
      if (console.isDebugEnabled) {
        console.group("function ajaxPerformUpload");
        console.debug("Arguments", arguments);
      }

      var upload = false;
      if (el.length == 0)
        return false;

      // append the uploadKey to the url
      var uploadUrl = url;
      var requestId = new Date().getTime();
      if (uploadUrl.indexOf('?') >= 0)
          uploadUrl = uploadUrl + "&UploadID=" + uploadKey + "&RequestID=" + requestId + "&FieldID=" + $(el).attr('name');
      else
          uploadUrl = uploadUrl + "?UploadID=" + uploadKey + "&RequestID=" + requestId + "&FieldID=" + $(el).attr('name');
      console.debug("Uploading to", uploadUrl);
          
      if ($.usingHtml5FileUpload) {
          uploadUrl = uploadUrl + "&nativeUpload=true";
          if (console.isDebugEnabled) {
              console.log("Using HTML5");
          }
          var data = {};
          data["UploadKey"] = uploadKey;
          el.each(function() {

              $(this).trigger('uploadstarted', data);

              // START HTML5 UPLOAD
              
              var xhr = new XMLHttpRequest();


              var self = this;
              var ElementName = $(this).attr('name');
              xhr.upload.addEventListener("progress", function(e) {
                  if (e.lengthComputable) {
                      var percentage = Math.round((e.loaded * 100) / e.total);

                      var progressData = {};

                      progressData["UploadKey"] = uploadKey;
                      progressData["TotalBytes"] = 0;
                      progressData["UploadedBytes"] = 0;
                      progressData["CurrentFile"] = '';
                      progressData["TotalPercent"] = percentage;
                      progressData["FileStatus"] = {};
                      $(self).trigger('uploadprogress', progressData);
                  }
              }, false);

              xhr.upload.addEventListener("load", function(e, d) {
                  var progressData = {};
                  console.log(this, e, d);
                  progressData["UploadKey"] = uploadKey;
                  progressData["TotalBytes"] = 0;
                  progressData["UploadedBytes"] = 0;
                  progressData["CurrentFile"] = '';
                  progressData["TotalPercent"] = 100;
                  progressData["FileStatus"] = {};
                  $(self).trigger('uploadprogress', progressData);

              }, false);
              xhr.elname = $(this).attr('name');
              xhr.el = this;
           //   console.log(this);
              xhr.onreadystatechange = function(e) {
                  if (this.readyState == 4 && this.status == 200) {
                      
                      var js = jQuery.parseJSON(this.responseText);
                      console.log("Complete", js);
                      js[xhr.elname].originalFieldId = ElementName;
                      $(this.el).trigger('uploadcompleted', { UploadKey: '', Response: js });
                  }
              };
              var uploadFileFn = function(fieldName, uploadUrl, fileData, xhr) {
                  var fd = new FormData();
                  fd.append(fieldName, fileData);
                  xhr.open("POST", uploadUrl);
                  xhr.send(fd);
              };
              
              // Check file limits, blocked files etc
              if (fileData.size > $.appSettings.uploadLimit * 1024) {
                  var fileSize = $.appSettings.uploadLimit;
                  var message = $.dictionary.getValue("error_uploadMaxLimitExceeded").replace("{0}", fileSize.toFixed(0)).replace("{1}", (fileSize / 1024).toFixed(2));
                  $.errorDialog(message);
                  $.ajaxActionHandlers.cancelAttachmentUpload({ Data: { FieldNames: { fieldId: ElementName }, Message: message } });
              }  else if (fileData.name.lastIndexOf(".") >= 0 && $.inArray(fileData.name.substr(fileData.name.lastIndexOf(".") + 1).toUpperCase(), $.appSettings.blockedFileTypes) >= 0) {
                  var message = $.dictionary.getValue("error_uploadFileTypeBlocked").replace("{0}", $.appSettings.blockedFileTypes.toString());
                  $.errorDialog(message);
                  $.ajaxActionHandlers.cancelAttachmentUpload({ Data: { FieldNames: { fieldId: xhr.elname }, Message: message } });
              } else if (fileData.size > $.appSettings.warnLimit * 1024) {
                  var fileSize = fileData.size / 1024 / 1024;
                  var warnMessage = $.dictionary.getValue("error_uploadWarnLimitExceeded").replace("{4}", fileData.name).replace("{3}", fileSize.toFixed(2));
                  $.confirmDialog(warnMessage, "Warning", function () {
                      uploadFileFn(ElementName, uploadUrl, fileData, xhr);
                  }, function () {
                      $.ajaxActionHandlers.cancelAttachmentUpload({ Data: { FieldNames: { fieldId: ElementName }, Message: $.dictionary.getValue("error_uploadUserCancelled") } });
                  });
              } else {
                  uploadFileFn(ElementName, uploadUrl, fileData, xhr);
              }
              // END HTML5 UPLOAD

          });
      }else {
        if (console.isDebugEnabled) {
          console.log("Using IFrame");
        }
          
        // Create a new IFRAME
        var iframe = $("<iframe />");
        iframe.uniqueId();
          var id = iframe.attr('id');
          var iFrameObj = iframe.attr('name', id).attr('id', id).appendTo($(document.body)).hide();
        // Create a new FORM
        var uploadUrlTmp = uploadUrl + "&fileName=" + fileData.name + "&ifUpload=true";
        if (el.attr('reupload') == 'true') {
          uploadUrlTmp = uploadUrlTmp + "&ignoreWarning=true";
          el.removeAttr('reupload');

        }
        
        var form = $('<form></form>').attr('target', id).attr('method', 'post').attr('action', uploadUrlTmp).appendTo($(document.body));
        form[0].encoding = 'multipart/form-data';
        iFrameObj.elname = $(el).attr('name');
          iFrameObj.el = el;
        var submitted = false;
          // When the iFRAME is loaded...
          $(iFrameObj.el).trigger('uploadindeterminate');
        iFrameObj.load(function () {
            console.log("loaded.....");
          if (submitted) {

            //$(iFrameObj[0].contentDocument.documentElement).find('body').text() + ")");
              // And invoke callback if one exists
              window.ifr = this;
              window.ifr1 = this.contentWindow;
              if (callback != null && this.contentWindow.attachResult != undefined) {
                  
                  callback(this.contentWindow.attachResult);
                  console.log("Complete", this.contentWindow.attachResult);
                  if (this.contentWindow.attachResult[iFrameObj.elname] != undefined) {
                      this.contentWindow.attachResult[iFrameObj.elname].originalFieldId = iFrameObj.elname;
                      $(iFrameObj.el).trigger('uploadcompleted', { UploadKey: '', Response: this.contentWindow.attachResult });
                  }
              }
              
            // Remove the iframe from the document
              window.setTimeout(function () { iFrameObj.remove(); }, 100);
            // Remove the form from the document
            form.remove();
          }
        });

        // Iterate through selected elements, trigger uploadStarted and append to new form
        var parents = {};
        el.each(function () {
          var data = {};
          data["UploadKey"] = uploadKey;
          $(this).attr('uploaded', 'true');
          if (console.isDebugEnabled) {
            console.debug("Trigger uploadStartedEvent", data);
          }
          $(this).trigger('uploadstarted', data);

          parents[$(this)[0]] = $(this).parent();
          $(this).appendTo(form);
        });
        // Submit the form via the iFrame
        submitted = true;
        if (console.isDebugEnabled) {
          console.debug("Submitting the form");
        }
        form.submit();

        // Move each element back to it's previous PARENT element
        el.each(function () {
          $(this).appendTo(parents[$(this)[0]]);
        });
      }
     
        if (console.isDebugEnabled)
        console.groupEnd();
      return true;
    },
    ajaxUpload: function (url, uploadKey, elementArray, fileData, _callback, asSingleRequest) {
        var callback = function (json) {
            $.handleAjaxResponse(json);
            
            if (_callback != undefined)
            _callback(json);
        };
      if (console.isDebugEnabled) {
        console.group("function ajaxUpload");
      }
        console.log(fileData);
      var uploaded = false;
        
      if (asSingleRequest == undefined || asSingleRequest == false) {
        console.log("Uploading single file input - ", elementArray.attr('uploadid'));
        var uploadid = elementArray.attr('uploadid');
        var elementsToUpload = elementArray.not('[uploaded]').not('[id = \'' + uploadid + '\']');
          
        if (elementsToUpload.length == 0) {
          if (console.isDebugEnabled) {
            console.log("Number of file inputs to upload ", elementsToUpload.length);
            console.groupEnd();
          }
          return false;
        }
        var result = $.ajaxPerformUpload(url, uploadKey, $(elementsToUpload[0]),fileData, callback);
        if (console.isDebugEnabled)
          console.groupEnd();
        return result;
      } else {
        var uploadid = elementArray.attr('uploadid');

        var result = $.ajaxPerformUpload(url, uploadKey, elementArray.not('[uploaded]').not('[name = \'' + uploadid + '\']'),fileData, callback);
        if (console.isDebugEnabled)
          console.groupEnd();
        return result;
      }
      if (console.isDebugEnabled)
        console.groupEnd();
      return false;

    }
  });
})(jQuery, console.getLogger("Upload"));
